import { useEffect, useState } from 'react';

export default function AboutSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth >= 768) { // Only on desktop
        setScrollY(window.scrollY);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section 
      id="about" 
      className="py-20 relative overflow-hidden"
      style={{
        backgroundColor: '#0D0F14',
        backgroundImage: `linear-gradient(rgba(10, 10, 10, 0.5), rgba(10, 10, 10, 0.5)), url('https://public.readdy.ai/ai/img_res/a1dd69aabf016ebc9cc253d5a9161f78.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/10 to-violet-900/10"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            About <span className="bg-gradient-to-r from-blue-400 to-violet-400 bg-clip-text text-transparent">Inspiring Life</span>
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-xl text-gray-300 leading-relaxed max-w-[750px] mx-auto">
              Founded on the principles of empowerment and innovation, Inspiring Life LLC bridges the gap between traditional business consulting and cutting-edge technology solutions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-white mb-6">Our Mission</h3>
            <div className="max-w-[750px]">
              <p className="text-lg text-gray-300 mb-6 leading-relaxed">
                We believe in the transformative power of knowledge, technology, and decentralized systems. Our mission is to empower businesses and individuals to achieve sustainable growth through strategic consulting, innovative digital solutions, and robust infrastructure.
              </p>
              <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                From trading psychology and business strategy to cloud hosting and blockchain networks, we provide comprehensive solutions that adapt to the evolving digital landscape.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-lg border border-gray-700/50">
                <div className="w-12 h-12 flex items-center justify-center border-2 border-blue-400 rounded-lg mb-4 bg-transparent">
                  <i className="ri-trophy-line text-xl text-blue-400"></i>
                </div>
                <h4 className="text-xl font-semibold text-white mb-2">Excellence</h4>
                <p className="text-gray-400">Delivering exceptional results through expertise and innovation</p>
              </div>
              
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-lg border border-gray-700/50">
                <div className="w-12 h-12 flex items-center justify-center border-2 border-violet-400 rounded-lg mb-4 bg-transparent">
                  <i className="ri-shield-check-line text-xl text-violet-400"></i>
                </div>
                <h4 className="text-xl font-semibold text-white mb-2">Trust</h4>
                <p className="text-gray-400">Building lasting relationships through transparency and reliability</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-700/50">
              <h3 className="text-2xl font-bold text-white mb-6">Why Choose Us?</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center border-2 border-blue-400 rounded-full flex-shrink-0 mt-1 bg-transparent">
                    <i className="ri-check-line text-blue-400 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">Comprehensive Expertise</h4>
                    <p className="text-gray-300 max-w-[750px]">From business consulting to technical infrastructure, we cover all aspects of modern enterprise needs.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center border-2 border-violet-400 rounded-full flex-shrink-0 mt-1 bg-transparent">
                    <i className="ri-check-line text-violet-400 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">Future-Ready Solutions</h4>
                    <p className="text-gray-300 max-w-[750px]">We leverage cutting-edge technologies including blockchain, cloud computing, and decentralized systems.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center border-2 border-blue-400 rounded-full flex-shrink-0 mt-1 bg-transparent">
                    <i className="ri-check-line text-blue-400 text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">Personalized Approach</h4>
                    <p className="text-gray-300 max-w-[750px]">Every solution is tailored to your specific needs and business objectives.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
